class Request {
    constructor() {
        const {
            common: {
                request: { get: ajaxGet, post: ajaxPost, bindCommonApi },
                behavior: { runBehaviour }
            }
        } = require('@futuweb/fego-render');
        this.get = ajaxGet;
        this.post = ajaxPost;
        this.runBehaviour = runBehaviour;
        this.bindCommonApi = bindCommonApi;
    }

    needLoginWrapper(res) {
        if (res.code === 10002) {
            this.runBehaviour(this, {
                type: 'login',
                value: location.href,
                withQuery: true
            });
        } else {
            return res;
        }
    }
}

export default new Request();
